import SplashScreen from './SplashScreen';

export default SplashScreen;



// WEBPACK FOOTER //
// ./src/shared/components/splashscreen/index.ts